module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "empty-state-try-screen-4.ebee77a8.png";